// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__60N1p","loaderInner":"Loader_loaderInner__RyDZF","spin":"Loader_spin__VfQ85","loaderText":"Loader_loaderText__Bi31K"};